import React, {useState} from 'react'
import { Box,Button, TextField, Typography, Autocomplete, useMediaQuery, useTheme} from '@mui/material'
import { useAppDispatch } from '../../../../redux/storeExports'
import { createExportLookerReportApi, ExportEmailRequest } from '../../../../redux/corporateCodeService'
import { validateEmail } from '../../../../utils/helpers'
    const ExportReportsTab=()=>{
        const theme = useTheme()
        const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
        const [exportValue, setExportValue] = useState('')
        const [emails, setEmails] = useState<string[]>([])
        const [ccEmails, setCCEmails] = useState<string[]>([])
        const [bccEmails, setBCCEmails] = useState<string[]>([])
        const [isLoading, setIsLoading] = useState(false)
        const dispatch = useAppDispatch()
        const [errors, setErrors] = useState({
          'to':false,
          'cc':false,
          'bcc':false
        })
        
        const onExport = async() =>{
            setIsLoading(true)
            const key = validateEmail(exportValue) ? 'email' : 'muid'
            const params : ExportEmailRequest = {
                search_key : key,
                search_value : exportValue,
                emails : emails,
                cc_emails : ccEmails,
                bcc_emails :  bccEmails,
            }
            await dispatch(createExportLookerReportApi(params))
            setIsLoading(false)
        }

        return(
            <Box sx={{display:'flex', alignItems:'center', justifyContent:'center', width:'100%', flexDirection:'column', minHeight:'50vh'}}>                
                <Typography variant='h2'sx={{mb:7}}>Export User Report PDF</Typography>
                <TextField
                    value={exportValue}
                    onChange={(e) => setExportValue(e.target.value.trim())}
                    label="*Export by Muid or Email"
                    size="small"
                    sx={{width: isMobile?'100%':'50%', mb:5}}
                />
                <Autocomplete
                    multiple
                    freeSolo
                    options={[]}
                    value={emails}
                    onChange={(event, newValue) =>{ 
                        let isValid = true
                        if(newValue.length > emails.length){
                            isValid = validateEmail(newValue[newValue.length -1])
                        }
                        if(isValid){
                            setEmails(newValue); 
                            setErrors({
                                ...errors,
                                to: false
                            })
                            return
                        }
                        else setErrors({
                        ...errors,
                        to: true
                        })
                        }}
                    renderInput={(params) => (
                        <TextField {...params} label="*To Email"
                    error={errors['to']}
                    helperText={errors['to']? "Enter a valid email address":""}
                    {...params}
                    variant="outlined"
                    />
                    )}
                    sx={{ width: isMobile?'100%':'50%'}}
                    isOptionEqualToValue={(option, value) => option === value}
                />

                <Autocomplete
                multiple
                freeSolo
                options={[]}
                value={ccEmails}
                onChange={(event, newValue) =>{ 
                        let isValid = true
                        if(newValue.length > ccEmails.length){
                            isValid = validateEmail(newValue[newValue.length -1])
                        }
                        if(isValid){
                            setCCEmails(newValue); 
                            setErrors({
                                ...errors,
                                cc: false
                            })
                            return
                        }
                        else setErrors({
                        ...errors,
                        cc: true
                        })
                        }}
                renderInput={(params) => (
                    <TextField {...params} label="Cc"
                    error={errors['cc']}
                    helperText={errors['cc']? "Enter a valid email address":""}
                    {...params}
                    variant="outlined"
                    />
                )}
                sx={{ width:isMobile?'100%':'50%', mt: 7 }}
                isOptionEqualToValue={(option, value) => option === value}
                />

                <Autocomplete
                multiple
                freeSolo
                options={[]}
                value={bccEmails}
                  onChange={(event, newValue) =>{ 
                        let isValid = true
                        if(newValue.length > bccEmails.length){
                            isValid = validateEmail(newValue[newValue.length -1])
                        }
                        if(isValid){
                            setBCCEmails(newValue);
                            setErrors({
                                ...errors,
                                bcc: false
                                })
                            return
                        }
                        else setErrors({
                        ...errors,
                        bcc: true
                        })
                        }}
                renderInput={(params) => (
                    <TextField {...params} label="Bcc"
                    error={errors['bcc']}
                    helperText={errors['bcc']? "Enter a valid email address":""}
                    {...params}
                    variant="outlined"
                    />
                )}
                sx={{ width: isMobile?'100%':'50%', mt:7}}
                isOptionEqualToValue={(option, value) => option === value}
                />
                <Button
                    variant={'contained'}
                    type={'button'}
                    disabled={isLoading || !exportValue || emails.length===0}
                    sx={{width:isMobile?'40%':'15%',border:'1px green solid', backgroundColor:"#fff", borderRadius:2, color:'success.main', p:3, mt:7,
                        '&:hover': {
                            backgroundColor:'success.main',
                            color:'#fff'
                            },
                         "&.Mui-disabled": {
                            backgroundColor: "#fff",
                            color: "#c0c0c0",
                            border:'1px #c0c0c0 solid'
                            },
                    }}

                    onClick={()=>{
                        onExport()
                    }}
                >
                    <Typography variant='h4' sx={{fontSize:'16px'}}>Export</Typography>
                </Button>
            </Box>
            )
}

export default ExportReportsTab
